import gql from 'graphql-tag';

export const PAUSE_BULK_AFFILIATE_OFFERS_LINK_ASYNC = gql`
  mutation PauseBulkAffiliateOfferLinksAsync($ids: [Int!]!, $removeAffiliates: Boolean) {
    pauseBulkAffiliateOfferLinksAsync(ids: $ids, removeAffiliates: $removeAffiliates)
  }
`;
